"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaChargeIugu = exports.yupChargeIugu = exports.schemaGetChargeIugu = exports.yupGetChargeIugu = exports.schemaPaymentIugu = exports.yupPaymentIugu = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupPaymentIugu = yup.object({
    event: yup.mixed().default(enums_1.ETypeWh.INVOICE_STATUS_CHANGED).label('Tipo do evento retorno'),
    data: yup
        .object({
        id: yup.string().default('').label('Id da cobrança'),
        status: yup.string().default('').label('Status da cobrança'),
        account_id: yup.string().default('').label('Id da cobrança'),
        payment_method: yup
            .mixed()
            .default(enums_1.EPaymentAttTypesIugu.IUGU_BANK_SLIP)
            .label('Tipo pagamento'),
        paid_at: yup.string().default('').label('Data de lançamento'),
        payer_cpf_cnpj: yup.string().default('').label('Documento pagador/cpf'),
        paid_cents: yup.string().default('').label('Valor da cobrança'),
        fee_cents: yup.string().default('').label('Valor da tarifa'),
        external_reference: yup.string().default('').label('Referência da cobrança'),
    })
        .label('Dados da cobrança'),
});
exports.schemaPaymentIugu = exports.yupPaymentIugu.shape({});
exports.yupGetChargeIugu = yup
    .object({
    id: yup.string().default('').label('Id da cobrança'),
    status: yup.string().default('').label('Status da cobrança'),
    account_id: yup.string().default('').label('Id da cobrança'),
    payment_method: yup
        .mixed()
        .default(enums_1.EPaymentAttTypesIugu.IUGU_BANK_SLIP)
        .label('Tipo pagamento'),
    paid_at: yup.string().default('').label('Data de lançamento'),
    payer_cpf_cnpj: yup.string().default('').label('Documento pagador/cpf'),
    total_paid_cents: yup.number().default(0).label('Valor total do pagamento'),
    taxes_paid_cents: yup.number().default(0).label('Valor tarifa'),
    external_reference: yup.string().default('').label('Referência da cobrança'),
})
    .label('Dados da cobrança');
exports.schemaGetChargeIugu = exports.yupGetChargeIugu.shape({});
exports.yupChargeIugu = yup.object({
    email: yup.string().email().required().max(80, 'Máximo de 80 caracteres').default('').label('E-mail do cliente'),
    cc_emails: yup
        .string()
        .email()
        .notRequired()
        .max(80, 'Máximo de 80 caracteres')
        .label('E-mail para cópia separados por ponto e vírgula'),
    due_date: yup.string().required().default('').label('Data de vencimento AAAA-MM-DD'),
    ensure_workday_due_date: yup.boolean().required().default(false).label('Vencimento em dias úteis.'),
    bank_slip_extra_due: yup
        .string()
        .notRequired()
        .default(undefined)
        .label('Prazo máximo para pagamento do boleto após o vencimento.'),
    items: yup
        .array(yup.object({
        description: yup.string().required().default('').label('Descrição do item'),
        quantity: yup.number().required().default(1).label('Quantidade do item.'),
        price_cents: yup.number().required().default(0).label('Preço do item em centavos.'),
    }))
        .default([])
        .label('Itens da fatura.'),
    payable_with: yup
        .array(yup.mixed())
        .required()
        .default([enums_1.EPaymentTypesIugu.BANK_SLIP])
        .label('Tipos de pagamento permitidos'),
    return_url: yup
        .string()
        .notRequired()
        .default(undefined)
        .label('Cliente é redirecionado para essa URL após efetuar o pagamento da Fatura pela página de Fatura da Iugu.'),
    expired_url: yup
        .string()
        .required()
        .default('')
        .label('Cliente é redirecionado para essa URL se a Fatura que estiver acessando estiver expirada.'),
    notification_url: yup
        .string()
        .notRequired()
        .default(undefined)
        .label('URL chamada para todas as notificações de Fatura, assim como os webhooks (Gatilhos) são chamados.'),
    ignore_canceled_email: yup.boolean().required().default(false).label('Desliga o e-mail de cancelamento de fatura.'),
    fines: yup.boolean().required().default(false).label('Habilitar multa por atraso de pagamento.'),
    late_payment_fine: yup
        .number()
        .notRequired()
        .default(undefined)
        .label('Determine a multa % a ser cobrada para pagamentos efetuados após a data de vencimento.'),
    late_payment_fine_cents: yup
        .number()
        .notRequired()
        .default(undefined)
        .label('Determine a multa por valor fixo a ser cobrada para pagamentos efetuados após a data de vencimento.'),
    per_day_interest: yup
        .boolean()
        .required()
        .default(false)
        .label('Determina se cobra ou não juros por dia de atraso. 1% ao mês pro rata. Necessário passar a multa como true.'),
    per_day_interest_value: yup
        .number()
        .notRequired()
        .default(undefined)
        .label('Informar o valor percentual de juros que deseja cobrar.'),
    per_day_interest_cents: yup
        .number()
        .notRequired()
        .default(undefined)
        .label('Juros a ser cobrado por dia em centavos. Tem prioridade sobre per_day_interest_value.'),
    discount_cents: yup.number().required().default(0).label('Valor dos Descontos em centavos.'),
    ignore_due_email: yup.boolean().required().default(false).label('Ignora o envio do e-mail de cobrança.'),
    payer: yup
        .object({
        cpf_cnpj: yup.string().required().default('').label('CPF ou CNPJ do cliente (apenas números)'),
        name: yup.string().required().default('').label('Nome (utilizado como sacado no boleto)'),
        phone_prefix: yup.string().notRequired().default(undefined).label('Prefixo (DDD) do telefone em dois dígitos'),
        phone: yup.string().notRequired().default(undefined).label('Telefone do cliente'),
        address: yup
            .object({
            zip_code: yup.string().required().default('').label('Código de Endereçamento Postal no Brasil (CEP)'),
            street: yup.string().required().default('').label('Rua'),
            number: yup.string().required().default('').label('Número. Se não houver, envie N/A'),
            district: yup.string().notRequired().default(undefined).label('Bairro'),
            city: yup.string().required().default('').label('Cidade'),
            state: yup.string().required().default('').label('Estado em sigla de Unidade Federativa (UF)'),
            country: yup.string().required().default('Brasil').label('País'),
            complement: yup.string().notRequired().default(undefined).label('Complemento'),
        })
            .required()
            .label('Endereço do cliente'),
    })
        .label('Informações do cliente'),
    external_reference: yup.string().required().default('').label('Lista de referência atrelada a cada cobrança gerada.'),
    max_installments_value: yup.number().notRequired().default(undefined).label('Número de parcelas'),
    early_payment_discount: yup
        .boolean()
        .required()
        .default(false)
        .label('Ativa ou desativa os descontos por pagamento antecipado.'),
    early_payment_discounts: yup
        .array(yup.object({
        days: yup
            .number()
            .notRequired()
            .default(undefined)
            .label('Juros a ser cobrado por dia em centavos. Tem prioridade sobre per_day_interest_value.'),
        percent: yup
            .number()
            .notRequired()
            .default(undefined)
            .label('Valor do desconto em porcentagem. Não pode ser usado com value_cents'),
        value_cents: yup
            .number()
            .notRequired()
            .default(undefined)
            .label('Valor do desconto em centavos. Não pode ser usado com percent.'),
    }))
        .notRequired()
        .default(undefined)
        .label('Quantidade de dias de antecedência para o pagamento receber o desconto.'),
});
exports.schemaChargeIugu = exports.yupChargeIugu.shape({});
